// @ts-nocheck
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';
import { Loader2, RefreshCw, Instagram, Twitter, AlertCircle } from 'lucide-react';
import SocialMediaFeed from './SocialMediaFeed';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

const SocialMediaManagement: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [lastFetch, setLastFetch] = useState<Date | null>(null);
  const { toast } = useToast();

  const handleFetchPosts = async () => {
    try {
      setIsLoading(true);
      
      const { data, error } = await invokeEdgeFunction('fetch-social-posts', {
        body: {}
      });

      if (error) {
        throw error;
      }

      toast({
        title: "Social Media Posts Updated",
        description: `Successfully processed ${data.postsInserted || 0} posts`,
        variant: "default",
      });

      setLastFetch(new Date());
    } catch (error) {
      console.error('Error fetching social media posts:', error);
      toast({
        title: "Error Fetching Posts",
        description: error instanceof Error ? error.message : "Failed to fetch social media posts",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <RefreshCw className="h-5 w-5" />
            Social Media Integration
          </CardTitle>
          <CardDescription>
            Manage and sync your social media posts from Instagram and X (Twitter)
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-4 p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2">
              <Instagram className="h-5 w-5 text-pink-500" />
              <span className="text-sm font-medium">Instagram</span>
            </div>
            <div className="flex items-center gap-2">
              <Twitter className="h-5 w-5 text-blue-500" />
              <span className="text-sm font-medium">X (Twitter)</span>
            </div>
            <div className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
              <AlertCircle className="h-4 w-4" />
              <span>API tokens configured via Supabase secrets</span>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm text-muted-foreground">
              {lastFetch ? (
                <span>Last updated: {lastFetch.toLocaleString()}</span>
              ) : (
                <span>Click fetch to sync your latest posts</span>
              )}
            </div>
            <Button 
              onClick={handleFetchPosts} 
              disabled={isLoading}
              className="flex items-center gap-2"
            >
              {isLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <RefreshCw className="h-4 w-4" />
              )}
              {isLoading ? 'Fetching...' : 'Fetch Latest Posts'}
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Recent Posts</CardTitle>
          <CardDescription>
            Your latest social media posts from connected platforms
          </CardDescription>
        </CardHeader>
        <CardContent>
          <SocialMediaFeed />
        </CardContent>
      </Card>
    </div>
  );
};

export default SocialMediaManagement;